import { getValueAtDate } from "@imminently/decisively-core";

export type ContactLike = {
  id: string;
  firstName?: unknown;
  lastName?: unknown;
};

/**
 * Returns a human-readable display name for a contact.
 * Uses the versioned firstName/lastName fields resolved at the given date.
 * Falls back to the contact's id if no name is available.
 */
export function getContactDisplayName(contact: ContactLike, date: Date = new Date()): string {
  // firstName/lastName are TemporalValue | PrimitiveValue at runtime; typed as unknown
  // here to accept both Contact and BackendResource<Contact> (which wraps fields in DeepPartial).
  const first = contact.firstName != null ? getValueAtDate(contact.firstName as any, date) : undefined;
  const last = contact.lastName != null ? getValueAtDate(contact.lastName as any, date) : undefined;
  const name = [first, last]
    .filter((v): v is string => typeof v === "string" && Boolean(v.trim()))
    .map((s) => s.trim())
    .join(" ");
  return name || contact.id;
}
